<!--  -->
<template>
	<div class="app">
		<Header></Header>
		<loginheader flagg="1"></loginheader>
		<div class="body">
			<div class="body-left">
				<div class="body-left-top">
					<img :src="infotopimg" alt />
					<h1>{{info.title}}</h1>
					<p>发布时间：{{info.create_time}}</p>
				</div>
				<div class="line"></div>
				<div class="body-left-body" v-html="info.content"></div>
				<div class="body-left-menu">
					<div v-for="(item, index) in info.keyword" :key="index">{{item}}</div>
				</div>
				<img :src="infobottomimg" alt class="body-left-bottom-img" />
				<div style="display:flex;flex-direction: row;margin:22px 0 16px">
					<div style="width: 6px;height: 24px;background: #365ad2;border-radius: 3px;"></div>
					<div style="  font-size: 26px;line-height: 20px;margin-left: 12px;">推荐内容</div>
				</div>
				<Recommend :recommend="articleInfo.hotAttr"></Recommend>
			</div>
			<div class="body-right">
				<div class="body-right-top">
					<img :src="info.publish_avatar" alt />
					<div class="body-right-top-name">
						<p>{{info.publish_name}}</p>
						<p>羁绊网官方...</p>
					</div>
				</div>
				<div class="s-line"></div>
				<div class="body-right-body">
					<div>作者：{{info.author}}</div>
					<div>来自：{{cate.title}}</div>
					<div>热度：{{info.hot}}</div>
				</div>
			</div>
		</div>
		<Fotter></Fotter>
	</div>
</template>

<script>
	//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
	//例如：import 《组件名称》 from '《组件路径》';
	import loginheader from "../loginheader.vue";
	import Fotter from "../Fotter.vue";
	import Header from "../Header.vue";
	import Recommend from "../Recommend.vue";
	export default {
		//import引入的组件需要注入到对象中才能使用
		components: {
			loginheader,
			Header,
			Fotter,
			Recommend
		},
		data() {
			//这里存放数据
			return {
				articleInfo: "",
				info: "",
				infotopimg: "",
				infobottomimg: "",
				cate: ""
			};
		},
		//监听属性 类似于data概念
		computed: {},
		//监控data中的数据变化
		watch: {},
		//方法集合
		methods: {},
		//生命周期 - 创建完成（可以访问当前this实例）
		created() {},
		//生命周期 - 挂载完成（可以访问DOM元素）
		mounted() {},
		beforeCreate() {
			this.$http.get("article/info/" + this.$route.query.id).then(res => {
				this.articleInfo = res.body.data;
				this.info = res.body.data.info;
				this.cate = res.body.data.info.cate;
				this.infotopimg = res.body.data.info.cont_pic[0];
				this.infobottomimg = res.body.data.info.cont_pic[1];
				console.log(res.body.data);
			});
		}, //生命周期 - 创建之前
		beforeMount() {}, //生命周期 - 挂载之前
		beforeUpdate() {}, //生命周期 - 更新之前
		updated() {}, //生命周期 - 更新之后
		beforeDestroy() {}, //生命周期 - 销毁之前
		destroyed() {}, //生命周期 - 销毁完成
		activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
	};
</script>
<style  scoped>
	.body-article-list {
		width: 890px;
		height: fit-content;
		min-height: 100px;
		border: 1px solid #cccccc;
		border-radius: 8px;
		margin: 20px 0;
	}
	.body {
		width: 1200px;
		margin: auto;
		padding-top: 20px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		padding-bottom: 40px;
	}
	.body-left {
		width: 920px;
	}
	.body-left-top {
		width: 920px;
	}
	.body-left-top img {
		width: 920px;
		height: 360px;
	}
	.body-left-top h1 {
		font-size: 26px;
		color: #212121;
		margin: 16px 0 10px;
	}
	.body-left-top p {
		color: #212121;
		font-size: 16px;
	}
	.line {
		height: 1px;
		background-color: #cccccc;
		width: 920px;
		margin: 40px 0 20px;
	}
	.body-left-menu {
		display: flex;
		flex-direction: row;
		margin: 30px 0;
	}
	.body-left-menu div {
		background-color: #f5f5f5;
		border-radius: 16px;
		width: fit-content;
		padding: 0 20px;
		height: 32px;
		line-height: 32px;
		margin-right: 30px;
		font-size: 14px;
		color: #212121;
	}
	.body-left-bottom-img {
		width: 920px;
		height: 150px;
	}
	.body-right-top {
		display: flex;
		flex-direction: row;
		width: 230px;
	}
	.body-right-top-name {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}
	.body-right-top > img {
		height: 90px;
		width: 90px;
		margin-right: 16px;
		border-radius: 8px;
	}
	.body-right-top-name > p {
		font-size: 18px;
	}
	.s-line {
		background-color: #cccccc;
		height: 1px;
		width: 230px;
		margin: 20px 0 16px;
	}
	.body-right-body div {
		font-size: 16px;
		margin-bottom: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/components/index/infoDetail.vue